// Data Lists
export const marketList = ['commodity', 'crypto', 'equities', 'forex'];
export const directionList = ['long', 'short'];
export const durationList = ['intraday', 'multiday'];
export const patternSpecificationList = [
    'broadly-symmetrical-high-side',
    'broadly-symmetrical-low-side',
    'extremely-high-slung',
    'extremely-low-slung',
    'high-slung',
    'low-slung',
    'perfectly-symmetrical',
];
//# sourceMappingURL=derived.js.map